<template>
  <div class="footer-brand">
    <UkaskoLogo :width="130" :height="47" />
    <Divider type="vertical" class="divider" />
    <p class="footer-brand__slogan">CRM-система для<br />страхового бізнесу</p>
  </div>
</template>

<script>
import { Divider } from '@/shared/ui/divider';
import { UkaskoLogo } from '@/shared/ui/icons';

export default {
  components: { UkaskoLogo, Divider },
};
</script>

<style lang="scss" scoped>
.footer-brand {
  display: flex;
  align-items: center;
  margin: 0 16px 16px;

  &__slogan {
    font-family: inherit;
    font-size: 14px;
    color: #71717A;
  }
}

.divider {
  height: 65px;
}
</style>
